import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { addModuleToCurrentThread } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import AddStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/add-stroke';
import DropdownMenu from '@ad-scripts/presentation/components/common/dropdown_menu_v2';
import SidekickModuleSpec from 'src/models/Sidekick/SidekickModuleSpec';
import useAddModifier from 'src/presentation/components/pages/sidekick/threads/hooks/useAddModifier';

type AddModuleProps = {
  aboveModuleId: string | null;
  className?: string;
  disabled: boolean;
  isVisible: boolean;
  moduleSpec: SidekickModuleSpec | null;
};

const AddModule = ({ className, aboveModuleId, moduleSpec, isVisible, disabled }: AddModuleProps) => {
  const dispatch = useDispatch();

  const { options } = useAddModifier({
    moduleId: aboveModuleId,
    moduleSpec,
    readOnly: disabled,
  });

  const handleSelect = (moduleName: string) => {
    dispatch(addModuleToCurrentThread({ moduleName, aboveModuleId, history }));
  };

  return (
    <AddModuleContainer isVisible={isVisible} className="add-module-button">
      <DropdownMenu
        options={options}
        fitOpenerWidth={true}
        onSelect={handleSelect}
        searchable
        renderCustomOpener={({ setTargetRef, onToggle }) => (
          <StyledAddModuleContainer
            className={className}
            disabled={disabled}
            onClick={onToggle}
            ref={setTargetRef}
            role="button"
          >
            <div>
              <div />
            </div>
            <AddStrokeIcon alt="Add Module" />
            <div>
              <div />
            </div>
          </StyledAddModuleContainer>
        )}
      />
    </AddModuleContainer>
  );
};

export const StyledAddModuleContainer = styled.div`
  display: flex;

  & > div {
    flex: 1;
    display: flex;
    align-items: center;
    & > div {
      width: 100%;
      height: 1px;
      border-top: 1px solid ${p => p.theme.colors.green400};
    }
  }

  fill: ${p => p.theme.colors.green400};

  svg {
    margin: 4px 8px;
    width: 16px;

    &:hover {
      cursor: pointer;
    }
  }
`;

const AddModuleContainer = styled.div`
  ${StyledAddModuleContainer} {
    visibility: hidden;
  }

  &:hover {
    ${StyledAddModuleContainer} {
      ${p => (p.isVisible ? 'visibility: visible' : 'visibility: hidden')};
    }
  }
`;

export default AddModule;
